import clsx from "clsx"
import { FC, memo, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { ISkipRegisteredLog } from "@/store/apis/gameplayAPI"
import styles from "./LogSkipRegistered.module.scss"

const LogSkipRegisteredComponent: FC<ISkipRegisteredLog> = (props) => {
  const { t } = useTranslation()

  const text = useMemo(() => {
    return t(`logs.turnSkipped.${props.details.reason}`)
  }, [props])

  return <span className={clsx(styles.LogEffectApplied)}>{text}</span>
}

export const LogSkipRegistered = memo(LogSkipRegisteredComponent)
